// removed by extract-text-webpack-plugin
module.exports = {"login-generic-error-wrapper":"GenericError__login-generic-error-wrapper","loginGenericErrorWrapper":"GenericError__login-generic-error-wrapper","signed-in-with":"GenericError__signed-in-with","signedInWith":"GenericError__signed-in-with"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/panels/GenericError/GenericError.scss
// module id = 1685
// module chunks = 8